import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  flagContainer: {
    position: 'absolute',
    width: '100%',
    maxWidth: 260,
    minWidth: 200,
    height: 'auto',
    left: -20,
    background: theme.colorPalette.white,
    padding: 32,
    paddingTop: 24,
    borderRadius: 6,
    boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.2)',
    transform: 'translateX(-100%)',
    marginLeft: -8,
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      transform: 'none',
      marginLeft: 0,
      marginBottom: theme.spacing(2),
      width: '100%',
      maxWidth: 'none',
      left: 0
    }
  },
  flagContent: {
    textAlign: 'left'
  },
  hintHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8
  },
  hintIcon: {
    width: 16,
    height: 16,
    marginRight: 8
  },
  hintTitle: {
    color: theme.colorPalette.gray_60,
    fontWeight: 600,
    fontSize: '12px',
    textTransform: 'uppercase'
  },
  flagMessage: {
    color: theme.colorPalette.green_90,
    marginTop: 0,
    wordBreak: 'break-word'
  },
  triangle: {
    width: 0,
    height: 0,
    borderTop: '11px solid transparent',
    borderLeft: `16px solid ${theme.colorPalette.white}`,
    borderBottom: '11px solid transparent',
    position: 'absolute',
    right: -16,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));

export default useStyles;
